import { render } from "./Loyalty.vue?vue&type=template&id=640b5b9c&scoped=true&ts=true"
import script from "./Loyalty.vue?vue&type=script&lang=ts"
export * from "./Loyalty.vue?vue&type=script&lang=ts"

import "./Loyalty.vue?vue&type=style&index=0&id=640b5b9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640b5b9c"]])

export default __exports__